import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@lsq/nextgen/v2/button';
import TeamsViewMenuCard from '../../shared/components/TeamsViewMenuCard/index';
import { ROUTES_PATH } from '../../../../constants/globalConstant';
import analytics from '../../../../utils/analytics';
import { ReactComponent as Add } from '../../../../assets/svgIcons/lsq_add.svg';

export const AnnouncementCell = ({ data, announcementById }) => {
  const navigate = useNavigate();
  const announcementId = data.announcement;
  const announcement = announcementById[announcementId];

  const teamsViewAnnouncementCardClicked = (announcementId) => {
    navigate(`${ROUTES_PATH.announcementBuilder}/${announcementId}`);
    analytics.sendEvent(`clicked Teams view announcement card`, {
      category: 'update_announcement',
      announcementId: announcementId
    });
  };

  const addAnnouncementCardClicked = () => {
    navigate(ROUTES_PATH.announcementBuilder);
  };

  return announcementId ? (
    <TeamsViewMenuCard
      menu={{
        name: announcement?.displayName || announcement?.name || 'Announcement',
        status: announcement?.status
      }}
      cardClickHandler={() => teamsViewAnnouncementCardClicked(announcementId)}
    />
  ) : (
    <Button
      size="xs"
      variant="secondary-gray"
      icon={<Add />}
      onClick={addAnnouncementCardClicked}
      data-testid="add-announcement-button"
      text="Add Announcement"
    />
  );
};
